import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as estimatesApi from '../api';
import type { Lang } from '../types';

export const templateKeys = { all: ['proposal-templates'] as const };

export function useProposalTemplates() {
  return useQuery({ queryKey: templateKeys.all, queryFn: estimatesApi.listProposalTemplates });
}

export function useSaveProposalTemplate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ language, driveFileId, name }: { language: Lang; driveFileId: string; name?: string }) =>
      estimatesApi.saveProposalTemplate(language, driveFileId, name),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: templateKeys.all }),
  });
}

export function useValidateProposalTemplate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => estimatesApi.validateProposalTemplate(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: templateKeys.all }),
  });
}
